import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { CategoryOverTimeComponent } from 'src/app/cxone/dashboard/modules/category-over-time/category-over-time.component';
import { CategoryOverTimeService } from 'src/app/cxone/dashboard/modules/category-over-time/category-over-time.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { GroupSelectorService } from 'src/app/reusables/group-selector/group-selector.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { IModuleManagerToolbarComponent } from 'src/shared/models/module-manager/module-manager-toolbar-component.model';

@Component({
    selector: 'cv-cxone-new-category-window',
    templateUrl: './cxone-new-category-window.component.html',
    styleUrls: ['./cxone-new-category-window.component.scss']
})
export class CxoneNewCategoryWindowComponent implements IModuleManagerToolbarComponent, OnInit, OnDestroy {
    @Input() moduleManager: ModuleManager;
    @Input() context?: any;

    private _settingsManagerSubscription: Subscription = null;
    private _settingsAppliedSubscription: Subscription = null;

    private category: string;
    private tnf: string;
    private range: string;

    constructor(private service: CategoryOverTimeService, private groupSelectorService: GroupSelectorService, private navService: NavigationService) {

    }

    ngOnInit(): void {
        this._settingsManagerSubscription = this.moduleManager.slideoutSettingsManager.subscribe((settingsManager) => {
            if (!settingsManager)
                return;

            if (this._settingsAppliedSubscription)
                this._settingsAppliedSubscription.unsubscribe();
            this._settingsAppliedSubscription = settingsManager.onSettingsApplied.subscribe(() => {
                this.loadTNF();
            })
        });
        this.loadTNF();
    }

    ngOnDestroy(): void {
        this._settingsAppliedSubscription?.unsubscribe();
        this._settingsManagerSubscription?.unsubscribe();
    }

    getCategoryId() {
        const settings = this.moduleManager.getModuleSettings();
        if (settings["autoSel"] == null || settings["autoSel"] || settings["selectedCategories"] == null || settings["selectedCategories"].length == 0) {
            (this.context as CategoryOverTimeComponent).getCategoryID();
        }
        else
            return settings["selectedCategories"][0].selectedCategories.id;
    }

    async loadTNF() {
        //get list of case sensitive team names
        let teams = await this.service.getCXoneTeamNames(this.moduleManager.getModuleKey());

        //generate tnf
        let tnf = "";
        teams.forEach((team) => {
            tnf = `${tnf}%2C${(<string>team.name).replace(" ", "%20")}`;
        });

        this.tnf = tnf;
    }

    getRange() {
        let start = this.moduleManager?.moduleSettings.selectedDateRange.startDate ?? null;
        let end = this.moduleManager?.moduleSettings.selectedDateRange.endDate ?? null;
        let days = this.moduleManager?.moduleSettings.selectedDateRange.numberOfDays ?? 0;
        if (start == null || end == null || days == 0)
            return "";

        let range = "";
        switch (days) {
            case 7:
                range = `3,${moment().valueOf()}`;
                break;
            case 30:
                range = `7,${moment().valueOf()},30`;
                break;
            default:
                range = `6,${moment().valueOf()},${moment(start).valueOf()},${moment(end).valueOf()}`;
                break;
        }

        return range;
    }

    openSearchWindow() {
        let url = `${this.navService?.cxoneTokenUrls?.niceBaseUrl ?? ""}`;

        this.range = this.getRange();
        this.category = (this.context as CategoryOverTimeComponent).getCategoryID();

        window.open(`${url}/search/#/search?page=1&sort=1startTime22&range=${this.range}&tnf=${this.tnf}&cat=${this.category}:A`, "_blank");
    }
}

export class CXoneNewWindowContext {

}
